// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectNumberInput_container__2Fpjb","label":"SelectNumberInput_label__1Cljo","select":"SelectNumberInput_select__1ws-A"};